import moment from 'moment'
import { useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

import {
  PARAM_GOING_ACTION,
  PARAM_MAYBE_ACTION,
  PARAM_NOT_GOING_ACTION,
} from 'app/constants/messageDetail'

export const ActionType = {
  SET_TOGGLE_GOING: 'SET_TOGGLE_GOING',
  SET_TOGGLE_MAYBE: 'SET_TOGGLE_MAYBE',
  SET_TOGGLE_NOT_GOING: 'SET_TOGGLE_NOT_GOING',
  SET_SUBSCRIBER_LIST: 'SET_SUBSCRIBER_LIST',
  SET_LOADING: 'SET_LOADING',
}

const initialState = {
  isGoing: false,
  isMaybe: false,
  isNotGoing: false,
  isLoading: false,
  subscriberList: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_TOGGLE_GOING:
      return {
        ...state,
        isGoing: action.value,
      }
    case ActionType.SET_TOGGLE_MAYBE:
      return {
        ...state,
        isMaybe: action.value,
      }
    case ActionType.SET_TOGGLE_NOT_GOING:
      return {
        ...state,
        isNotGoing: action.value,
      }
    case ActionType.SET_SUBSCRIBER_LIST:
      return {
        ...state,
        subscriberList: action.value,
        isLoading: false,
      }
    case ActionType.SET_LOADING:
      return {
        ...state,
        isLoading: action.value,
      }
    default:
      return state
  }
}

export default function useEvent(id) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()

  const commonDispatch = useDispatch()

  const handleAlertError = () => {
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }

  const fetchActionEvent = (id, actionParam) => {
    dispatch({ type: 'SET_LOADING', value: true })
    effects.apis
      .getNotiEventSubscribers({ notificationId: id, action: actionParam })
      .then((response) => {
        dispatch({
          type: 'SET_SUBSCRIBER_LIST',
          value: response.data.map((list) => list.subscriber),
        })
      })
      .catch(() => handleAlertError())
  }

  const handleToggleGoing = (bool) => {
    dispatch({ type: 'SET_TOGGLE_GOING', value: bool })
    if (bool) fetchActionEvent(id, PARAM_GOING_ACTION)
  }

  const handleToggleMaybe = (bool) => {
    dispatch({ type: 'SET_TOGGLE_MAYBE', value: bool })
    if (bool) fetchActionEvent(id, PARAM_MAYBE_ACTION)
  }

  const handleToggleNotGoing = (bool) => {
    dispatch({ type: 'SET_TOGGLE_NOT_GOING', value: bool })
    if (bool) fetchActionEvent(id, PARAM_NOT_GOING_ACTION)
  }

  const handleDownload = (fileType, id) => {
    const mimeType = fileType === 'pdf' ? 'application/pdf' : 'text/csv'
    effects.apis
      .downloadEventNotification({
        notificationId: id,
        action: fileType,
      })
      .then((response) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(
          new Blob([response], { type: mimeType }),
        )

        link.setAttribute(
          'download',
          `Event_Invitees_${moment.utc().format('MM-DD-YYYY')}.${fileType}`,
        )
        document.body.appendChild(link)

        link.click()
        link.remove()
      })
      .catch(() => handleAlertError())
  }

  return {
    state,
    handleDownload,
    handleToggleGoing,
    handleToggleMaybe,
    handleToggleNotGoing,
  }
}
